import React from 'react';
import {
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    ResponsiveContainer
} from 'recharts';

interface Skill {
    name: string;
    percentage: number;
}

interface SkillsSpiderChartProps {
    skills: Skill[];
}

const SkillsSpiderChart: React.FC<SkillsSpiderChartProps> = ({ skills }) => {
    // Filter out skills with 0 percentage
    const validSkills = skills.filter(s => s.percentage > 0);

    if (validSkills.length === 0) {
        return (
            <div className="flex items-center justify-center h-64 text-gray-500">
                No skill data available
            </div>
        );
    }

    return (
        <ResponsiveContainer width="100%" height={400}>
            <RadarChart data={validSkills}>
                <PolarGrid stroke="#E5E7EB" />
                <PolarAngleAxis
                    dataKey="name"
                    tick={{ fill: '#6B7280', fontSize: 14 }}
                    style={{ textTransform: 'capitalize' }}
                    dy={-10}
                />
                <PolarRadiusAxis
                    angle={90}
                    domain={[0, 100]}
                    tick={{ fill: '#9CA3AF', fontSize: 12 }}
                />
                <Radar
                    name="Expertise"
                    dataKey="percentage"
                    stroke="#3B82F6"
                    fill="#3B82F6"
                    fillOpacity={0.5}
                />
            </RadarChart>
        </ResponsiveContainer>
    );
};

export default SkillsSpiderChart;
